export const protocol = "https";
export const host = "backend-production-dot-singular-vector-400507.ey.r.appspot.com";
// export const host = process.env.REACT_APP_HOST_URL;
// export const host = "192.168.29.14:8000";
export const port = "";
export const trailUrl = "";
